import React from "react";
import Box from "@mui/joy/Box";
import Typography from "@mui/joy/Typography";
import Avatar from "@mui/joy/Avatar";
import Sheet from "@mui/joy/Sheet";
import Chip from "@mui/joy/Chip";
import Button from "@mui/joy/Button";
import Headerchat from "./headergrupal";
import ContenidoChatGrupal from "./contenidochatgrupal";

export default function VentanaChatGrupal({ datoschat, datosaventura }) {
  return (
    <Box
      sx={{
        display: "grid",
        height: "100vh",
        gridTemplateRows: { md: "15% 85%", xs: "35% 85%" },
      }}
    >
      <Headerchat datoschat={datoschat} datosaventura={datosaventura} />
      <ContenidoChatGrupal datoschat={datoschat} />
    </Box>
  );
}
